import { render, staticRenderFns } from "./smsReceived.vue?vue&type=template&id=52f6ea12"
import script from "./smsReceived.vue?vue&type=script&lang=js"
export * from "./smsReceived.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports